import React from "react";
import { InputSize, InputStatus } from "./input-helper";
import classNames from "classnames";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Extend classnames
   */
  extendClasses?: string;
  /**
   * Prefix
   */
  inputPrefix?: React.ReactNode;
  /**
   * Surfix
   */
  inputSurfix?: React.ReactNode;
  /**
   * Has bordered
   */
  bordered?: boolean;
  /**
   * Size of input
   */
  inputSize?: InputSize;
  /**
   * Status
   */
  status?: InputStatus;
}

const InputFwRef: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputProps
> = (
  {
    extendClasses,
    inputPrefix,
    inputSurfix,
    bordered,
    inputSize = "medium",
    disabled,
    status,
    ...props
  },
  ref
) => {
    return (
      <div
        className={classNames({
          tfcInput: true,
          [`tfcInput-${inputSize}`]: true,
          [`tfcInput-${inputSize}`]: true,
          [`tfcInput-${status}`]: !!status,
          [`tfcInput-bordered`]: bordered,
          [`tfcInput-disabled`]: disabled,
          [extendClasses as string]: !!extendClasses,
        })}
      >
        {inputPrefix}
        <input
          ref={ref}
          {...props}
          disabled={disabled}
        />
        {inputSurfix}
      </div>
    );
  };

export const Input = React.forwardRef(InputFwRef);

export default Input;
